<app-card #card 
    cardTitle="Rendszer"
    [showEdit]="false" >
      
    <div class="action-buttons">
        <button mat-flat-button color="primary" (click)="testDatabaseRestore()" *ngIf="isTestMode">
            <mat-icon>list_alt_add</mat-icon> Éles adatok áthozása
        </button>
        <!-- <button mat-flat-button color="primary" (click)="purgeCache()">Cache törlés</button> -->
    </div>
    
</app-card>